import script from "./PayslipBreakdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayslipBreakdown.vue?vue&type=script&setup=true&lang=ts"

import "./PayslipBreakdown.vue?vue&type=style&index=0&id=0e74fada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e74fada"]])

export default __exports__